import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { LAYOUT_TYPE_PATH, CARD_SIZE_PATH } from '../../constants/wix-params';
import { LAYOUT_TYPE_PINBOARD } from '../../../app/constants/layout-types';
import { CARD_SIZE_SMALL, CARD_SIZE_LARGE } from '../../../app/constants/card-sizes';
import MasonryWrapper from '../../components/masonry-wrapper';
import PostListMasonry from './post-list-masonry';
import PostListClassic from './post-list-classic';
import PostListMobile from './post-list-mobile';
import PostListLarge from './post-list-large';
import Loader from '../../components/loader';
import withAppSettings from '../../hoc/with-app-settings';
import withDeviceType from '../../hoc/with-device-type';
import withPermissions from '../../hoc/with-permissions';
import LoadMore from '../../components/load-more';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { incrementPostLikeCount } from '../../actions/increment-post-like-count';
import styles from './post-list.scss';

class PostList extends Component {
  getListComponent = () => {
    let Component;
    const { isMobile, layout, cardSize } = this.props;
    if (isMobile) {
      Component = PostListMobile;
    } else if (layout === LAYOUT_TYPE_PINBOARD && cardSize === CARD_SIZE_LARGE) {
      Component = PostListLarge;
    } else if (layout === LAYOUT_TYPE_PINBOARD) {
      Component = PostListMasonry;
    } else {
      Component = PostListClassic;
    }

    return Component;
  };

  isInfiniteList = () => {
    const { isMobile, layout, cardSize } = this.props;
    return isMobile || (layout === LAYOUT_TYPE_PINBOARD && cardSize !== CARD_SIZE_LARGE);
  };

  shouldFadeIn = () => {
    const { layout, cardSize, isMobile } = this.props;
    return !isMobile && layout === LAYOUT_TYPE_PINBOARD && cardSize !== CARD_SIZE_LARGE;
  };

  renderComponent = () => {
    const Component = this.getListComponent();
    const {
      isLoading,
      currentPagePosts,
      allPosts,
      page,
      entityCount,
      isLoaded,
      loadMore,
      changePage: handlePageChange,
      ...props
    } = this.props;
    if (this.isInfiniteList()) {
      return (
        <LoadMore loadMore={loadMore} loader={<Loader/>} isLoading={isLoading} hasMore={allPosts.length < entityCount}>
          <Component posts={allPosts} entityCount={entityCount} {...props}/>
        </LoadMore>
      );
    }

    return (
      <div>
        <Component
          page={page}
          entityCount={entityCount}
          onPageChange={handlePageChange}
          isLoading={isLoading}
          isLoaded={isLoaded}
          posts={currentPagePosts}
          {...props}
        />
      </div>
    );
  };

  render() {
    const { hasSpacing } = this.props;

    const containerClassName = classNames(styles.container, 'post-list', {
      [styles.hasSpacing]: hasSpacing,
    });

    return (
      <div className={containerClassName}>
        <MasonryWrapper isEnabled={this.shouldFadeIn()}>
          {this.renderComponent()}
        </MasonryWrapper>
      </div>
    );
  }
}

PostList.propTypes = {
  onLikeClick: PropTypes.func.isRequired,
  loadMore: PropTypes.func.isRequired,
  changePage: PropTypes.func,
  currentPagePosts: PropTypes.array,
  category: PropTypes.object,
  allPosts: PropTypes.array,
  location: PropTypes.object,
  query: PropTypes.string,
  isMobile: PropTypes.bool,
  layout: PropTypes.number,
  cardSize: PropTypes.number,
  entityCount: PropTypes.number,
  page: PropTypes.number,
  isLoading: PropTypes.bool,
  isLoaded: PropTypes.bool,
  hasSpacing: PropTypes.bool,
};

PostList.defaultProps = {
  layout: LAYOUT_TYPE_PINBOARD,
  cardSize: CARD_SIZE_SMALL,
  hasSpacing: true,
};

const mapStateToProps = (state, { category, canSee }) => ({
  showCreatePostAction: category && (!category.isWriteProtected || canSee('create-post', 'category', category)),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    onLikeClick: incrementPostLikeCount,
  }, dispatch);

export default flowRight(
  withAppSettings({
    cardSize: CARD_SIZE_PATH,
    layout: LAYOUT_TYPE_PATH,
  }),
  withDeviceType,
  withPermissions,
  connect(mapStateToProps, mapDispatchToProps), // Should stay last
)(PostList);



// WEBPACK FOOTER //
// ./app/components/post-list/post-list.js